<template>
  <v-main>
    <v-overlay :value="$storeBourse.loader">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="text-subtitle-1 text-center" cols="12">
          <span class="deep-purple--text"> Vérification de la CNI. </span>
        </v-col>
        <v-col cols="6">
          <v-progress-linear
            color="deep-purple accent-4"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-row>
    </v-overlay>
    <div v-if="!$storeBourse.premiereEtape.cniValide">
      <span>N° de CNI non connu.</span>
    </div>
    <div v-else>
      <div v-if="$storeBourse.premiereEtape.peutCreer">
        <Candidat  :affichageAutreRevenu="affichageAutreRevenu" v-if="!$storeBourse.premiereEtape.creer" ref="refCandidat" />
        <v-card
          v-if="$storeBourse.premiereEtape.creer"
          elevation="2"
          width="90%"
          class="pa-md-4 mx-auto"
        >
          <v-card-text>
            Votre dossier a bien été envoyé. Merci de suivre les instructions qui
            vous seront envoyé par mail afin de completer votre dossier.
          </v-card-text>
        </v-card>
        <br />
        <v-row align="center" justify="space-around">
          <v-btn
            large
            class="pa-md-4 mx-auto"
            dark
            color="ecSecondary"
            elevation="1"
            v-show="
              !$storeBourse.DonneesFormulaireEC.readOnly &&
              !$storeBourse.premiereEtape.afficherMessage
            "
            @click="Enregistrer"
          >
            Envoyer mon dossier
          </v-btn>
        </v-row>
      </div>
      <div v-else>
        <v-card
          elevation="2"
          width="90%"
          class="pa-md-4 mx-auto"
        >
          <v-card-text>
            <p>
                Il y a déjà une candidature existante avec le même CNI. Veuillez
                vous connecter directement sur
                <a :href="LienPortail" target="_blank">l'extranet.</a>
              </p>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <br />
  </v-main>
</template>
<script>
import Candidat from "@/components/BourseEcoleCentrale/Candidat";

export default {
  name: "DossierBourseEcoleCentrale",
  components: {
    Candidat,
  },
  data() {
    return {
      $storeBourse: this.$storeBourse,
      $storeCatalogue: this.$storeCatalogue,
      affichageAutreRevenu: false,
      LienPortail: process.env.VUE_APP_LIEN_PORTAIL_ECOLE_CENTRALE,
    };
  },
  created(){
    this.LienPortail = process.env.VUE_APP_LIEN_PORTAIL_ECOLE_CENTRALE;
  },
  mounted() {
    this.ChargerCatalogues();
    let cni = this.$route.params.cni;
    // Vérifier cni
    this.$storeBourse.GetCni(cni);
  },
  methods: {
    ChargerCatalogues() {
      this.$storeCatalogue.ChargerCatalogueCandidatureBourseEcoleCentrale();
    },
    Enregistrer() {
      let listeErreurs = this.$refs.refCandidat.ValiderForm().flat();
      if (listeErreurs.length > 0) {
        this.$storeBourse.AfficherListeErreurs(listeErreurs);
      } else {
        this.$storeBourse.CreerDossier();
      }
    },
  },
};
</script>
